document.addEventListener(
  "DOMContentLoaded",
  () => {
    function initSlider(containerId, prevId, nextId) {
      const $methods = document.getElementById(containerId);
      const $prev = document.getElementById(prevId);
      const $next = document.getElementById(nextId);

      // 绑定导航按钮点击事件
      $prev.addEventListener("click", () => {
        const itemWidth = $methods.children[0].offsetWidth * 3;
        $methods.scrollLeft -= itemWidth;
      });

      $next.addEventListener("click", () => {
        const itemWidth = $methods.children[0].offsetWidth * 3;
        $methods.scrollLeft += itemWidth;
      });

      $methods.addEventListener("scroll", () => {
        if ($methods.scrollLeft <= 0) {
          $prev.classList.add("loyalty-nav-button-disabled");
        } else {
          $prev.classList.remove("loyalty-nav-button-disabled");
        }

        if ($methods.scrollLeft + $methods.clientWidth >= $methods.scrollWidth) {
          $next.classList.add("loyalty-nav-button-disabled");
        } else {
          $next.classList.remove("loyalty-nav-button-disabled");
        }
      });
    }
    initSlider("loyalty-earn-methods", "loyalty-nav-btn-prev", "loyalty-nav-btn-next");
    // 可以在加载完数据后再初始化
    // initSlider("loyalty-coupons", "loyalty-coupons-btn-prev", "loyalty-coupons-btn-next");
  },
  false
);
